// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"744b9348","264":"39ebf262","418":"07059832","480":"1c8c604e","638":"1a5a21ea","854":"d122c922"}[chunkId] + ".chunk.js";
};